import React, { useState } from 'react';
import {
    Box,
    Typography,
    Button,
    Card,
    CardContent,
    FormControlLabel,
    Radio,
    RadioGroup,
    FormControl,
} from '@mui/material';

const questions = [
    {
        id: 'disqualifiedDriving',
        question: 'Under FMCSR 391.15, are you currently disqualified from driving a commercial motor vehicle? [49 CFR 391.15]',
        reference: '',
    },
    {
        id: 'revokedLicense',
        question: 'Has your license, permit or privilege to drive ever been suspended or revoked for any reason? [49 CFR 391.21(b)(9)]',
        reference: '',
    },
    {
        id: 'deniedLicense',
        question: 'Have you ever been denied a license, permit, or privilege to operate a motor vehicle? [49 CFR 391.21(b)(9)]',
        reference: '',
    },
    {
        id: 'testedPositive',
        question: 'Within the past two years, have you tested positive, or refused to test, on a pre-employment drug or alcohol test by an employer to whom you applied, but did not obtain, safety-sensitive transportation work covered by DOT agency drug and alcohol testing rules? [49 CFR 40.25(j)]',
        reference: '',
    },
    {
        id: 'convictedOffense',
        question: 'In the past three(3) years, have you ever been convicted of any of the following offenses: [49 CFR 391.15]',
        reference: `• Driving a commercial motor vehicle with a blood alcohol concentration ("BAC") of .04 percent or more
• Driving under the influence of alcohol, as prescribed by state law
• Refusal to undergo drug and alcohol testing as required by any jurisdiction for the enforcement of Federal Motor Carrier Safety Act regulations
• Driving a commercial motor vehicle under the influence of any 21 C.F.R. 1308.11 Schedule I identified controlled substance, an amphetamine, a narcotic drug, a formulation of an amphetamine, or a derivative of a narcotic drug
• Transportation, possession, or unlawful use of a 21 C.F.R. 1308.11 Schedule I identified controlled substance, amphetamines, narcotic drugs, formulations of an amphetamine, or derivatives of narcotic drugs while you were on duty driving for a motor carrier
• Leaving the scene of an accident while operating a commercial motor Vehicle
• Or any other felony involving the use of a commercial motor vehicle`,
    },
];

function FMCSRQuestions({ onNext }) {
    const [answers, setAnswers] = useState({
        disqualifiedDriving: '',
        revokedLicense: '',
        deniedLicense: '',
        testedPositive: '',
        convictedOffense: '',
    });

    const handleAnswerChange = (questionId) => (event) => {
        setAnswers({
            ...answers,
            [questionId]: event.target.value === 'true'
        });
    };

    const isFormComplete = () => {
        return Object.values(answers).every(answer => answer !== '');
    };

    const handleSubmit = () => {
        if (isFormComplete()) {
            onNext({
                disqualified_driving: answers.disqualifiedDriving,
                revoked_license: answers.revokedLicense,
                denied_license: answers.deniedLicense,
                tested_positive: answers.testedPositive,
                convicted_offense: answers.convictedOffense,
            });
        }
    };

    return (
        <Box sx={{ maxWidth: 900, mx: 'auto', p: 3 }}>
            <Typography variant="h6" gutterBottom>FMCSR Questions</Typography>

            <Card variant="outlined" sx={{ mb: 3 }}>
                <CardContent>
                    {questions.map((q) => (
                        <Box key={q.id} sx={{ mb: 3 }}>
                            <Typography gutterBottom>{q.question}</Typography>
                            {q.reference && (
                                <Typography
                                    variant="body2"
                                    color="text.secondary"
                                    sx={{ whiteSpace: 'pre-line', ml: 2, my: 1 }}
                                >
                                    {q.reference}
                                </Typography>
                            )}
                            <FormControl required>
                                <RadioGroup
                                    row
                                    value={answers[q.id].toString()}
                                    onChange={handleAnswerChange(q.id)}
                                >
                                    <FormControlLabel
                                        value="true"
                                        control={<Radio />}
                                        label="Yes"
                                    />
                                    <FormControlLabel
                                        value="false"
                                        control={<Radio />}
                                        label="No"
                                    />
                                </RadioGroup>
                            </FormControl>
                        </Box>
                    ))}
                </CardContent>
            </Card>

            <Box sx={{ mt: 3 }}>
                <Button
                    variant="contained"
                    color="primary"
                    fullWidth
                    onClick={handleSubmit}
                    disabled={!isFormComplete()}
                >
                    Continue
                </Button>
            </Box>
        </Box>
    );
}

export default FMCSRQuestions;
